import React from "react";
import clsx from "clsx";

import styles from "./Button.module.css";

export enum ButtonSize {
  tiny = "tiny",
  medium = "medium",
  big = "big",
  large = "large",
}

export enum ButtonDesign {
  basic = "basic",
  primary = "primary",
  secondary = "secondary",
  ghost = "ghost",
  basicGray = "basicGray",
}

export interface ButtonProps {
  children?: React.ReactNode;
  className?: string;
  design?: ButtonDesign;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  fit?: boolean;
  fluid?: boolean;
  isLoading?: boolean;
  size?: ButtonSize;
  as?: React.ElementType;
  type?: string;
  pulse?: boolean;

  [key: string]: unknown;
}

const Button: React.FC<ButtonProps> = ({
  children,
  className = "",
  design = ButtonDesign.basic,
  fit = false,
  fluid = false,
  isLoading = false,
  pulse = false,
  disabled = false,
  onClick = () => {},
  size = ButtonSize.big,
  as = "button",
  type = "button",
  ...rest
}: ButtonProps) => {
  return React.createElement(
    as,
    {
      className: clsx(
        styles.Button,
        {
          [styles[design]]: true,
          [styles[size]]: true,
          [styles.fit]: fit,
          [styles.fluid]: fluid,
          [styles.isLoading]: isLoading,
          [styles.pulse]: pulse,
        },
        className,
      ),
      disabled,
      onClick,
      as,
      type,
      ...rest,
    },
    children,
  );
};

export default Button;
